<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import ../../common/styles/vendors/burger

    .disclaimer
        background: transparentize($color-base,  0.2)
        height: auto
        padding: 1.5rem
        box-sizing: border-box
        display: none
        position: fixed
        top: 6rem
        z-index: 3
        width: 100%
        text-align: center
        transition: transform $speed-normal $authentic-motion
        transform: none
        color: #fff
        font-size: 18px

        +media("<=1024px")
          top: 4rem

        +media("<=768px")
          font-size: 16px

        +media("<=425px")
          font-size: 14px

        &.mt-hidden
          transform: translateY(-6rem)

          +media("<=1024px")
            transform: none

    .page-type-homepage_corporate
      .disclaimer
        display: block !important

    .menu-top
        background: transparentize($color-base,  0.2)
        height: 6rem
        padding: 1.5rem
        box-sizing: border-box
        display: flex
        justify-content: flex-end
        align-items: center
        position: fixed
        top: 0
        z-index: 20
        width: 100%
        transition: transform $speed-normal $authentic-motion
        transform: none
        .page-type-product_sante &,
        .page-type-homepage_sante &
            background: $color-blue !important

        .toolbar-fixed &
            top: 39px
        .toolbar-fixed.toolbar-horizontal &
            top: 79px

        &.hide
            transform: translateY(-100%)

        &.hide-background
            background: none

        &.show-burger
            height: 4rem
            padding: 1rem 2rem
            background: $color-base
            +media("<=768px")
                padding: 1rem
            .menu-top__logo
                width: 8rem
                +media("<=768px")
                    width: 8rem
                img
                    width: 7.2rem

            .menu-top__burger
                display: flex

            .toolbar-tray-open &
                top: 78px

        +media("<=1024px")
            background: $color-base !important
            transform: none !important
            height: 4rem
            padding: 1rem 2rem

        &__left
            flex-grow: 1
            display: flex
            align-items: center
            height: 100%

        &__right
            display: flex
            align-items: center
            height: 100%
            white-space: nowrap
            +media("<=1024px")

            font-size: 0.9rem

        &__logo
            height: 100%
            +media("<tablet")
                .menu-top--open &
                    display: none
            img
                height: 100%


        &__burger
            height: 100%
            cursor: pointer
            justify-content: center
            display: flex
            flex-direction: row
            align-items: center
            margin-left: 40px
            display: none
            //.page-type-homepage_sante &
            //    display: none !important

            &__icon
                +burger(30px, 3px, 5px, #FFF)

            +media("<=1000px")
                &__icon
                    position: relative
                    top: 2px

            +media("<tablet")
                position: absolute
                right: 20px

            &__label
                color: white
                margin-left: 1rem
                +media("<=1000px")
                    display: none

            &.open
                .menu-top__burger__icon
                    +burger-to-cross

        // &__section
        //     pointer-events: none
        //     margin-left: 2rem
        //     pointer-events: all
        //     padding: 0 0 0.5rem 0
        //     border-bottom: 1px solid white
        //     cursor: pointer

        //     .arrow
        //         border: none
        //         width: 1rem
        //         height: 1rem

        //         & svg
        //             margin-top: 0
        //             width: 100%
        //             height: 100%

        //             > *
        //                 fill: white

        &__section
            // margin-right: 40px
            margin-left: 40px
            +media("<tablet")
                display: none
                .menu-top--open &
                    display: block
                    margin-left: 2px
                    margin-right: 0
            .v-select
                pointer-events: none
                min-width: 200px
                .vs__dropdown-toggle
                    background-color: transparent
                    border: 0px
                    border-bottom: 1px solid white
                    border-radius: 0
                .vs__selected-options
                    padding: 0 0
                .vs__selected
                    color: white
                    font-size: 14px
                    opacity: 1 !important
                    padding-left: 0
                    margin-left: 0
                .vs__open-indicator
                    background: none
                .vs__actions
                    position: absolute
                    right: 0
                    padding-left: 190px
                    pointer-events: auto
                    top: 4px
                .vs__dropdown-menu
                    display: none !important

                // .vs__dropdown-menu
                //     border-radius: 0
                //     box-shadow: none
                //     border: 0
                //     margin: 0
                //     padding: 0
                //     background: #d02a4c
                //     opacity: 0.8
                //     .page-type-homepage_sante &
                //         background: transparentize($color-blue, 0.2)
                //     +media("<tablet")
                //         width: 100vw
                //         left: -18px
                //         right: 0
                //         position: absolute
                //         opacity: 1
                //         top: 48px
                //         background: white
                // .vs__dropdown-option
                //     margin-left: 0
                //     padding-left: 10px
                //     padding: 10px 10px
                //     color: white
                //     border-bottom: 1px solid rgba(255,255,255,0.5)
                //     +media("<tablet")
                //         padding: 22px
                //         padding-left: 33px
                //         color:  #d02a4c
                //         border-bottom: 1px solid  #d02a4c
                //         .page-type-homepage_sante &
                //             color: $color-blue
                //             border-bottom: 1px solid $color-blue
                //     +media(">=tablet")
                //         &:last-child
                //             border-bottom: 0
                //     &--highlight
                //         background: none

            &_arrow svg
                width: 1rem
                height: 1rem
                .vs--open &
                    transform: rotate(180deg)
                > *
                    fill: white

        &__link
            color: white
            margin-right: 4rem
            display: inline-block

            &--underline
                &:hover
                    text-decoration: underline
            +media("<=1024px")
                margin-right: 1rem
            svg
                vertical-align: middle
                margin-right: 0.25rem

            &--blog
                +media("<tablet")
                    display: none
                svg
                    width: 1.25rem
                    fill: white

            &--mail
                +media("<tablet")
                    display: none
                svg
                    width: 1.25rem

            &--people svg
                width: 1.1rem

            &--lock
                svg
                    fill: white

            &--recrutement
                margin-right: 0

                +media("<tablet")
                    margin-right: 45px !important

                svg
                    height: 1.9rem
                    fill: white

            .people-color, .mail-color, .lock-color
                stroke: white
                stroke-width: 2px
                fill: transparent

            +media("<=1000px")
                font-size: 0
                margin-right: 0
                margin-left: 1rem

        &__lang
            color: white
            margin-right: 4rem

            +media("<=1000px")
                margin: 0 2rem

            +media("<=tablet")
                margin: 0

        &__lang_link--disabled
            opacity: 0.5

    .menu-profiles--open
        .menu-top__section
            .v-select
                .menu-top__section_arrow
                    svg
                        transform: rotate(180deg)

</style>

<script>

    import $ from 'jquery'
    import { once } from 'lodash/core'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        components: {
            "vSelect": vSelect
        },

        data() {
            return {
                section: "Mon profil",
                mode: ""
            }
        },

        watch: {
            /*
            section() {
                if ( location.href.indexOf(this.section.code) === -1 ) {
                    location.href = this.section.code;
                }
            }
            */
        },

        mounted: function() {

            let options = this.$refs["sectionSelect"].options;
            options.forEach((option) => {
                if ( location.href.indexOf('entreprise') > -1 && (option.code === '/en/node/16')) {
                    this.section = option;
                }
                if ( location.href.indexOf(option.code) > - 1 ) {
                    this.section = option;
                }
            });

            this.isMobile = ( $(window).width() <= 1000 );

            // TODO
            let mode = "page";

            if ( $('.page-type-homepage_corporate').length > 0 )
                mode = "homepage-corporate";
            else if ( $('.page-type-homepage_sante').length > 0 )
                mode = "homepage-sante";
            else if ( $('.page-type-customer_area').length > 0 )
                mode = "homepage-sante";
            else if ( $('.page-type-espace-client,' +
                        '.page-search,.page-type-floating,' +
                        '.page-type-contact,' +
                        '.page-type-customer_area,' +
                        '.page-type-press,' +
                        '.page-type-legal,' +
                        '.page-type-about_us,' +
                        '.page-type-expertise,' +
                        '.page-type-groupe,' +
                        '.page-type-article,' +
                        '.page-type-liste_articles,' +
                        '.page-type-agency,' +
                        '.page-type-newsletter').length > 0 )
                mode = "corporate";
            else if ( $('.page-type-homepage_part,' +
                        '.page-type-homepage_pro').length > 0 && !this.isMobile )
                mode = "homepage";

            this.mode = mode;

            switch( mode ) {
                case "page" :
                    this.managePage();
                    break;
                case "homepage-corporate" :
                    this.manageHomepageCorporate();
                    break;
                case "homepage-sante" :
                    this.manageHomepageSante();
                    break;
                case "corporate":
                    this.manageCorporate();
                    break;
                case "homepage" :
                    this.manageHomepage();
                    break;
            }

            // TODO Move.
            $(".menu-generic__container__right").on("click", () => {
                if ( $(".menu-generic__container__right .show-content").length === 0 )
                    this.closeSubMenu();
            });
            $("body").on("click", (event) => {
                if ( $(".menu-generic").length  )
                    if ( !$(".menu-generic").get(0).contains(event.target) && !$(".menu-top").get(0).contains(event.target) )
                        this.closeSubMenu();
            })
        },

        methods: {

            onSectionClick() {
                if ( document.body.classList.contains("menu-profiles--open") ) {
                    this.closeProfilsMenu();
                } else {
                    this.openProfilsMenu();
                }
            },

            managePage() {
                this._manageSticky();
                $(this.$el).addClass("show-burger");
            },

            manageHomepageCorporate() {
               // $('.disclaimer').css('display', 'block');
                if ( this.isMobile )
                    $(this.$el).addClass("show-burger");
                this._manageSticky();
                this._manageLinks();
            },

            manageHomepageSante() {
                if ( this.isMobile )
                    $(this.$el).addClass("show-burger");
                this._manageSticky();
                this._manageLinks();
            },

            manageCorporate() {
                if ( this.isMobile )
                    $(this.$el).addClass("show-burger");
                this._manageSticky();
                $(this.$el).addClass('show-links');
            },

            manageHomepage() {
                let lastScrollTop = $(window).scrollTop();

                $(this.$el).addClass("hide-background");

                let manage = () => {
                  console.log('lsjdg');
                    let st = $(window).scrollTop();

                    if ( st > 400 )
                        $(this.$el).addClass("show-burger");
                    else
                        $(this.$el).removeClass("show-burger");


                    if ( st <= lastScrollTop && st > 640 ) {
                        $(this.$el).removeClass('hide');
                      } else {
                        $(this.$el).addClass('hide');
                    }

                    if ( st <= 50 )
                        $(this.$el).removeClass("hide");

                    lastScrollTop = st;
                };

                $(document).on('scroll', () => manage());
                manage();
            },

            _manageSticky() {
                let lastScrollTop = $(window).scrollTop();
                let manage = () => {
                    let st = $(window).scrollTop();

                    if (st <= lastScrollTop) {
                        $(this.$el).removeClass('hide');
                    } else {
                        $(this.$el).addClass('hide');
                    }

                    if ( st <= 50 )
                        $(this.$el).removeClass('hide');

                    lastScrollTop = st;

                    /*if ($('.menu-top').hasClass('hide')) {
                      $('.disclaimer').addClass('mt-hidden');
                    } else {
                      $('.disclaimer').removeClass('mt-hidden');
                    }*/
                };
                $(document).on('scroll', () => manage());
                manage();
            },

            _manageLinks() {
                let manage = () => {
                    let st = $(window).scrollTop();
                    if ( st > $(window).height() )
                        $(this.$el).addClass('show-links');
                    else
                        $(this.$el).removeClass('show-links');
                };
                $(document).on('scroll', () => manage());
                manage();
            },

            openProfilsMenu() {
                this.closeSubMenu();
                document.body.classList.add("menu-profiles--open");
                if ( !this.isMobile ) {
                    $(document).on("scroll", once(() => {
                        setTimeout(() => { this.closeProfilsMenu(); }, 100);
                    }));
                } else {
                    $(this.$refs.burger).addClass('open');
                }
            },

            openProfilsMobileMenu() {
                $(this.$refs.burger).addClass('open');
                document.body.classList.add("menu-profiles--open");
            },

            closeProfilsMenu() {
                document.body.classList.remove("menu-profiles--open");
            },

            closeProfilsMobileMenu() {
                $(this.$refs.burger).removeClass('open');
                document.body.classList.remove("menu-profiles--open");
            },

            openSubMenu() {
                let $body = $("body");
                $(this.$refs.burger).addClass('open');
                $body.addClass('menu-top--open');
                $body.addClass('menu-top--animation');
                $('.node-homepage__shortcut').hide();
                setTimeout(() => $body.removeClass('menu-top--animation'), 600);
                this.closeProfilsMenu();
                if ( !this.isMobile ) {
                  $(document).on("scroll", once(() => {
                        setTimeout(() => { this.closeSubMenu(); }, 100);
                    }));
                }
            },

            closeSubMenu() {
              let $body = $("body");
                $(this.$refs.burger).removeClass('open');
                $body.removeClass('menu-top--open');
                $body.addClass('menu-top--animation');
                $('.node-homepage__shortcut').show();
                setTimeout(() => $body.removeClass('menu-top--animation'), 600);
                $(window).trigger("MenuGeneric:close");
            },

            toggle() {
                if ( $(this.$refs.burger).hasClass('open') ) {
                    if ( this.isMobile ) {
                        this.closeProfilsMobileMenu();
                        this.closeSubMenu();
                    } else {
                        this.closeSubMenu();
                    }
                } else {
                    if ( this.isMobile &&  ( this.mode == "homepage-corporate" || this.mode == "homepage-sante" ) ) {
                        this.openProfilsMobileMenu();
                    } else {
                        this.openSubMenu();
                    }
                }
            }

        }

    }

</script>
